<div class="scaffold-view-component-holder">
  <app-rendered *ngFor="let it of items;let $i = index" [childview]="childview" [item]="it" [arr]="items" [info]="info"></app-rendered>
  <a pTooltip="Configure {{this.info.type}}: {{this.info.view_details.title || this.info.view_details.mode}} View"
     attr.aria-label="Configure {{this.info.type}}: {{this.info.view_details.title || this.info.view_details.mode}} View"
     tooltipPosition="left" *ngIf="info && info.view_id && this.info.view_details && userInfo && userInfo.manage_views" class="view-link" href="/views/{{info.view_id}}/edit" target="_blank">
    <i class="fas fa-cogs"></i>
  </a>
</div>
